import { useMemo } from "react";
import {
  ArchiveBoxArrowDownIcon,
  ChevronLeftIcon,
  ChevronDownIcon,
  EllipsisHorizontalIcon,
  TrashIcon,
  EnvelopeIcon,
  CheckBadgeIcon,
} from "@heroicons/react/24/outline";

const GmailPreviewHeader = ({ subject, merchantName, primaryColour }) => {
  const initial = merchantName.charAt(0).toUpperCase();
  const dateLabel = useMemo(() => {
    const now = new Date();
    return `${now.getDate()} ${now.toLocaleDateString("en-GB", { month: "short" })}`;
  }, []);

  return (
    <div className="cursor-default py-2">
      {/* Gmail-style toolbar */}
      <div className="flex items-center justify-between px-2 pt-2 pb-1 text-zinc-700">
        <ChevronLeftIcon className="size-4" />
        <div className="flex items-center gap-3">
          <ArchiveBoxArrowDownIcon className="size-3" />
          <TrashIcon className="size-3" />
          <EnvelopeIcon className="size-3" />
          <EllipsisHorizontalIcon className="size-3" />
        </div>
      </div>

      {/* Subject */}
      <div className="px-2.5 pt-2 pb-1 flex items-center justify-between">
        <span className="text-sm font-medium text-zinc-900 leading-snug flex-1">
          {subject || "No subject"}
          &nbsp;&nbsp;
          <span className="text-[8px] text-zinc-700 bg-zinc-100 px-[4px] py-[1px] rounded-[3px] inline-flex font-semibold">
            Inbox
          </span>
        </span>
        <svg
          className="shrink-0 mt-1"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#9ca3af"
          strokeWidth="2"
        >
          <polygon points="12,2 15,9 22,9 16.5,14 18.5,21 12,17 5.5,21 7.5,14 2,9 9,9" />
        </svg>
      </div>

      {/* Sender row */}
      <div className="flex items-center gap-2.5 px-2.5 py-2">
        <div
          className="w-7 h-7 rounded-full shrink-0 flex items-center justify-center text-white text-xs font-bold"
          style={{ backgroundColor: primaryColour || "#6b7280" }}
        >
          {initial}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1">
              <span className="text-[8px] font-semibold text-zinc-900 truncate">
                {merchantName}
              </span>
              <CheckBadgeIcon className="size-2.5 text-blue-600" />
              <span className="text-[8px] text-zinc-600">{dateLabel}</span>
            </div>
          </div>
          <p className="text-[8px] text-zinc-600 mt-0.5">
            to me &nbsp;&nbsp;
            <ChevronDownIcon className="size-1.5 text-zinc-600 inline-flex" />
          </p>
        </div>
      </div>
    </div>
  );
};

export default GmailPreviewHeader;
